import { useEffect, useRef, useState } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { useBooking } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';
import type { TicketCartItem } from 'hb-react/shared/components/ShoppingCard/hooks/v2';
import UpdateInformationModal from 'hb-react/shared/components/User/UpdateInformationModal';
import { useUserDataSubscriber } from 'hb-react/shared/components/User/UpdateInformationModal/hooks/useUserDataSubscriber';

const SuccessWithUpdateUserModal = ({ children }) => {
  const { currentUser } = useDefaultAppContexts();
  const [openModal, setOpenModal] = useState(false);
  const hasOpenedModal = useRef(false);

  const { cart, metadata } = useBooking();

  const attendee = cart?.cart_items
    ?.filter(
      (item): item is TicketCartItem =>
        item.line_itemable_type === 'NetworkEvents::Ticket',
    )
    .find((item) => item?.metadata?.event?.user_id === currentUser?.id);

  const { isModified, changeSet } = useUserDataSubscriber({
    user: currentUser,
    formState: {
      billing_address_attributes: {
        ...cart?.billing_address,
        postal_address_type: cart?.payload?.address_type,
      },
      mobile_perso: attendee?.metadata?.event?.mobile_phone,
      email: metadata?.user?.email ?? attendee?.metadata?.event?.email,
      firstname:
        metadata?.user?.firstname ?? attendee?.metadata?.event?.firstname,
      lastname: metadata?.user?.lastname ?? attendee?.metadata?.event?.lastname,
    },
  });

  const onClose = () => {
    hasOpenedModal.current = true;
    setOpenModal(false);
  };

  useEffect(() => {
    if (isModified) {
      setOpenModal(true);
    }
  }, [isModified]);

  if (isModified && !hasOpenedModal.current && openModal) {
    return (
      <>
        {children}
        <UpdateInformationModal
          changeSet={changeSet}
          onSuccess={onClose}
          onClose={onClose}
        />
      </>
    );
  }

  return children;
};

export default SuccessWithUpdateUserModal;
